import { Route } from 'types/route.type';

import { routes as aerators } from './features/aerators/routes';
import { routes as feeders } from './features/feeders/routes';
import { routes as feedCatalog } from './features/feed-catalog/routes';
import { routes as treatmentCatalog } from './features/treatment-catalog/routes';

export const routes: Route[] = [...feedCatalog, ...treatmentCatalog, ...aerators, ...feeders];
